import React, { useMemo, useState } from 'react'
import { useSelector } from 'react-redux'
import DetailsResults from './DetailsResults'
import useMediaQuery from 'hooks/useMediaQuery'

import {
  encounter as loadEncounter,
  encounterReadLoading
} from '@enlyt/stores/Fhir/Select'
import { parseEncounter } from '@enlyt/helpers/parse'

import localization from '../localization'
import themeStyles from './styles'
import { useTheme } from 'contexts/ThemeProvider'
import _ from 'lodash'
import withLocalization from '@web/helpers/localizationUtils'
import {
  Button,
  Container,
  Divider,
  Grid,
  GridColumn,
  GridRow,
  List,
  ListItem,
  Segment,
  PlaceholderLine,
  Placeholder,
  PlaceholderHeader
} from 'semantic-ui-react'
import { format } from 'date-fns'
import { activeLanguage, getDateLocale } from '@web/providers/Localization/i18n'

const ResultItem = ({ test, t, isFirstResult }) => {
  const { theme, isDark } = useTheme()
  const styles = themeStyles(theme)
  const testInfo = useMemo(() => Object.values(test), [test])
  const testDates = useMemo(() => Object.keys(test), [test])
  const encounterId = useMemo(
    () => _.get(testInfo, '[0][0].encounterId', 0),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [test]
  )
  const encounter = useSelector(loadEncounter(encounterId))
  const isLoading = useSelector(encounterReadLoading(encounterId))

  const { isMobile, isTablet } = useMediaQuery()

  const lastTestDate = useMemo(
    () => {
      return testDates[0]
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [test]
  )

  const orderProvider = useMemo(() => {
    const provider = parseEncounter(encounter)

    return provider ? provider.location : ''
  }, [encounter])

  const [isOpen, setIsOpen] = useState(isFirstResult || false)

  if (isLoading) {
    return (
      <Segment inverted={isDark} style={styles.loadingContainer}>
        <Placeholder inverted={isDark} fluid>
          <PlaceholderHeader image>
            <PlaceholderLine length='very long' />
            <PlaceholderLine length='very long' />
          </PlaceholderHeader>
        </Placeholder>
      </Segment>
    )
  }

  const testDate = new Date(Object?.keys(test)?.[0])

  const testDateFormatted = {
    month: format(testDate, 'MMMM', {
      locale: getDateLocale(activeLanguage())
    }).toUpperCase(),
    day: testDate.toLocaleString('default', { day: 'numeric' }),
    year: testDate.toLocaleString('default', { year: 'numeric' })
  }

  return (
    <div style={styles.contentContainer}>
      <Segment inverted={isDark}>
        <Grid style={styles.expandableCard}>
          <GridRow style={styles.cardRow(isMobile || isTablet)}>
            <GridColumn
              style={styles.calendarCardContainer(isMobile || isTablet)}
            >
              <div style={styles.calendarCard}>
                <div style={styles.month}>{testDateFormatted.month}</div>
                <div style={styles.day}>{testDateFormatted.day}</div>
                <div style={styles.year}>{testDateFormatted.year}</div>
              </div>
            </GridColumn>
            <GridColumn style={styles.providerContainer(isMobile || isTablet)}>
              <List style={styles.listTitle}>
                <ListItem>{t('orderProvider')}</ListItem>
              </List>
              <List style={styles.listSubtitle}>
                <ListItem style={styles.listSubtitle}>{orderProvider}</ListItem>
              </List>
            </GridColumn>
            <GridColumn style={styles.button}>
              <Button
                tabIndex={0}
                style={styles.expandButton}
                onClick={() => setIsOpen(!isOpen)}
                icon={isOpen ? 'angle up' : 'angle down'}
              />
            </GridColumn>
          </GridRow>
        </Grid>
        {isOpen && (
          <>
            <Divider style={styles.customDivider} />
            <Container>
              <List>
                <ListItem>
                  <div style={styles.groupsContainer}>
                    <div style={styles.groupContentContainer}>
                      <DetailsResults
                        test={test}
                        testDates={testDates}
                        lastTestDate={lastTestDate}
                      />
                    </div>
                  </div>
                </ListItem>
              </List>
            </Container>
          </>
        )}
      </Segment>
    </div>
  )
}

export default withLocalization(ResultItem, localization)
